import {
  captureFunnelEvent,
  type FunnelCaptureClient,
} from './capture-funnel-event';
import { readResponseStartedAt } from './capture-response-started';
import type { ResponseFunnelTarget } from './capture-response.types';
import { createSessionOnceGuard } from './session-once-guard';

const completedGuard = createSessionOnceGuard('response_completed_');

function resolveDurationSeconds(responseId: string): number | undefined {
  const startedAt = readResponseStartedAt(responseId);
  if (startedAt === null) return undefined;

  const ms = Date.now() - startedAt;

  return ms >= 0 ? Math.round(ms / 1000) : undefined;
}

export function captureResponseCompletedOnce(
  posthog: FunnelCaptureClient | null | undefined,
  { projectId, responseId }: ResponseFunnelTarget
): void {
  if (!projectId || !responseId || completedGuard.has(responseId)) return;

  completedGuard.mark(responseId);

  const durationSeconds = resolveDurationSeconds(responseId);

  captureFunnelEvent(posthog, 'response_completed', {
    project_id: projectId,
    response_id: responseId,
    ...(durationSeconds !== undefined
      ? { duration_seconds: durationSeconds }
      : {}),
  });
}
